document.addEventListener("DOMContentLoaded", () => {

/* Apply first time discount */
  const applyFirstTimerDiscountButton = document.getElementById('cart-apply-new-customer-discount-button');

  applyFirstTimerDiscountButton.addEventListener('click', (event) => {
    event.preventDefault();

    const discountCode = applyFirstTimerDiscountButton.dataset.discountCode;
    console.log(discountCode);

    let formData = {discount: `${discountCode}`};
    console.log(formData);

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        // window.location.href = "/cart/checkout";
        location.reload();
        
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  });

});